import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./fr.json";
import en from "./en.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    lng: "fr",           // langue par défaut
    fallbackLng: "fr",
    interpolation: { escapeValue: false },
  });

/**
 * Appeler cette fonction au login pour changer la langue selon la licence :
 * - "eu" → anglais
 * - "dz" | "fr" → français
 */
export function setLangueFromLicence(licence) {
  const lang = licence === "eu" ? "en" : "fr";
  if (i18n.language !== lang) i18n.changeLanguage(lang);
}

export default i18n;
